export default __webpack_public_path__ + "static/member-plant-2-1-53bda1bb59983b7c8f6d74bb34f14603.png";